const cross = (a, b, c) => (b.x - a.x) * (c.y - a.y) - (b.y - a.y) * (c.x - a.x);
const intersects = (a, b, c, d) => cross(a, b, c) * cross(a, b, d) <= 1e-9 &&
  cross(c, d, a) * cross(c, d, b) <= 1e-9 &&
  Math.max(Math.min(a.x, b.x), Math.min(c.x, d.x)) <= Math.min(Math.max(a.x, b.x), Math.max(c.x, d.x)) + 1e-9 &&
  Math.max(Math.min(a.y, b.y), Math.min(c.y, d.y)) <= Math.min(Math.max(a.y, b.y), Math.max(c.y, d.y)) + 1e-9;

export function canAppendVertex(points, point) {
  if (points.some((p) => Math.hypot(p.x - point.x, p.y - point.y) < 1e-5)) return false;
  if (points.length < 2) return true;
  const last = points[points.length - 1], previous = points[points.length - 2];
  // Reject retracing the preceding edge as well as crossing older edges.
  if (Math.abs(cross(previous, last, point)) < 1e-9 &&
      (point.x - last.x) * (previous.x - last.x) + (point.y - last.y) * (previous.y - last.y) > 0) return false;
  return !points.slice(0, -2).some((p, i) => intersects(p, points[i + 1], last, point));
}

export function snapVertex(point, candidates, tolerance) {
  let closest = null, distance = tolerance;
  candidates.forEach((p) => {
    const d = Math.hypot(p.x - point.x, p.y - point.y);
    if (d <= distance) { closest = p; distance = d; }
  });
  return closest;
}
